import { ComponentRoute } from '@/classes'

const AdvanceReceiptRoutes = {
  AdvanceReceiptModal: new ComponentRoute('/advancereceipts/:id', 'AdvanceReceiptModal')
}

export default AdvanceReceiptRoutes